module.exports = __webpack_public_path__ + "img/import_export-white-18dp.2cd5da95.svg";